import SidebarLayout from '../../components/SidebarLayout';
import SubjectsForm from '../../components/sections/MTSS/SubjectsForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function Categories() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-subject');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<SubjectsForm />}
          heading={'Add Subject'}
        />
      </div>
    </AccessWrapper>
  );
}
